var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-mail",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "-6.5 -9.115 30 30",
    enableBackground: "new -6.5 -9.115 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    fill: "#8A1538",
    d: "M20.796-0.647l-6.47,6.587c-0.045,0.045-0.045,0.118-0.005,0.164 c0.003,0.001,0.005,0.003,0.005,0.004l4.525,4.817c0.304,0.306,0.307,0.798,0.003,1.104c-0.002,0.002-0.003,0.003-0.003,0.003 c-0.309,0.303-0.802,0.303-1.105,0L13.24,7.235c-0.049-0.049-0.126-0.049-0.175,0l0,0l-1.101,1.117 c-0.905,0.93-2.15,1.455-3.449,1.456C7.189,9.806,5.92,9.263,4.995,8.311L3.938,7.236c-0.048-0.049-0.126-0.049-0.175,0l0,0 l-4.507,4.798c-0.306,0.304-0.8,0.304-1.106,0c-0.306-0.305-0.307-0.798-0.004-1.101c0.001-0.002,0.002-0.003,0.002-0.004 l4.527-4.821c0.041-0.049,0.041-0.121,0-0.168l-6.47-6.587c-0.046-0.046-0.121-0.048-0.17-0.001C-3.987-0.626-4-0.595-4-0.562 v13.18c0.002,1.06,0.862,1.918,1.924,1.921h21.152c1.063-0.003,1.921-0.861,1.924-1.921V-0.557c0.003-0.065-0.05-0.122-0.118-0.123 C20.85-0.682,20.818-0.669,20.796-0.647z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    fill: "#8A1538",
    d: "M8.5,8.234c0.887,0.004,1.733-0.348,2.353-0.983l9.432-9.597 c-0.338-0.274-0.757-0.424-1.191-0.422H-2.083C-2.517-2.77-2.937-2.622-3.272-2.347l9.429,9.596C6.773,7.882,7.618,8.236,8.5,8.234 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9f4486fe1aaa980543c19e1eba32b7a7.svg";
export { ForwardRef as ReactComponent };